import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import MainLayout from "@/components/layout/MainLayout";
import Dashboard from "@/pages/Dashboard";
import QuotationPage from "@/pages/QuotationPage";
import InvoicePage from "@/pages/InvoicePage";
import ServiceBillPage from "@/pages/ServiceBillPage";
import RecordsPage from "@/pages/RecordsPage";
import AccountingPanel from "@/pages/AccountingPanel";
import PanelSelector from "@/components/auth/PanelSelector";

function App() {
  const [panel, setPanel] = useState(sessionStorage.getItem("panel") || null);

  const handlePanelSelected = () => {
    setPanel(sessionStorage.getItem("panel"));
  };

  const handleSignOut = () => {
    sessionStorage.removeItem("panel");
    setPanel(null);
  };

  // No panel selected → show selector
  if (!panel) {
    return (
      <>
        <PanelSelector onPanelSelected={handlePanelSelected} />
        <Toaster position="top-right" richColors />
      </>
    );
  }

  // Accounting panel
  if (panel === "accounting") {
    return (
      <>
        <AccountingPanel onSignOut={handleSignOut} />
        <Toaster position="top-right" richColors />
      </>
    );
  }

  // Dealership panel
  return (
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLayout onSignOut={handleSignOut} />}>
            <Route index element={<Dashboard />} />
            <Route path="quotation" element={<QuotationPage />} />
            <Route path="invoice" element={<InvoicePage />} />
            <Route path="service-bill" element={<ServiceBillPage />} />
            <Route path="records" element={<RecordsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
